// Pre-discount (strikethrough) display prices for the consumer tiers sold at a discount through
// Stripe, keyed by discounted cents. The mapping comes from the pricing sheet
// (docs.google.com/spreadsheets/d/1AfTo7YQtrEiC8ODGb1lfckzGExx_S4xeEtDqfcDoZWo) rather than a
// formula: most tiers are 20% off, but not all (Plus monthly is $5.99 → $7.99, 25% off).
const PRE_DISCOUNT_CENTS: Record<number, number> = {
  399: 499, // Lite monthly
  1199: 1499, // Lite yearly
  599: 799, // Plus monthly
  1599: 1999, // Plus yearly and Pro monthly
  7999: 9999, // Pro yearly
  3999: 4999 // Classic one-time
}

// A discounted price missing from the table falls back to 20% off (cents / 0.8).
export function preDiscountCents(discountedCents: number): number {
  return PRE_DISCOUNT_CENTS[discountedCents] ?? Math.round(discountedCents / 0.8)
}
